import defs from "../modules";

export default {
  install(Vue) {
    Vue.prototype.accessRole = function(role) {
      if (role === "superuser")
        return this.$store.state.auth.token.superuser || false;
      else if (role === "admin" || role === "administrator")
        return this.$store.state.auth.token.superuser
          || this.$store.state.auth.company.administrator
          || false;
      else if (role === "dispatcher")
        return this.$store.state.auth.token.superuser
          || this.$store.state.auth.company.administrator
          || this.$store.state.auth.company.dispatcher
          || false;
      else
        return (role === "driver" || role == null);
    };

    Vue.prototype.accessAuthority = function(authority) {
      if (authority === undefined || authority === null)
        return true;
      else if (authority === "contract")
        return this.$store.state.auth.company.moduleContracts || false;
      else
        return false;
    };

    Vue.prototype.canRead = function(module = null) {
      const def = defs[module || this.$store.state.data.module];
      return def !== undefined && def.role !== undefined
        && this.accessRole(def.role.read)
        && this.accessAuthority(def.role.authority);
    };

    Vue.prototype.canWrite = function(module = null) {
      const def = defs[module || this.$store.state.data.module];
      return def !== undefined && def.role !== undefined
        && this.accessRole(def.role.write)
        && this.accessAuthority(def.role.authority);
    };

    Vue.prototype.canDelete = function(module = null) {
      const def = defs[module || this.$store.state.data.module];
      return def !== undefined
        && def.role !== undefined
        && this.accessRole((def.role.delete !== undefined) ? def.role.delete : def.role.write)
        && this.accessAuthority(def.role.authority);
    };
  }
};